import { render, staticRenderFns } from "./ReviewBoosterPageControls.vue?vue&type=template&id=7dc942c5&scoped=true&"
import script from "./ReviewBoosterPageControls.vue?vue&type=script&lang=js&"
export * from "./ReviewBoosterPageControls.vue?vue&type=script&lang=js&"
import style0 from "./ReviewBoosterPageControls.vue?vue&type=style&index=0&id=7dc942c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc942c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
